import { render, staticRenderFns } from "./Prototipo.vue?vue&type=template&id=04e36e06"
import script from "./Prototipo.vue?vue&type=script&lang=js"
export * from "./Prototipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports